// @ts-nocheck
import classNames from 'clsx'
import { bool, number, string } from 'prop-types'

import {
  DEFAULT_NUMBER_OF_VISIBLE_ITEM,
  VISIBLE_COUNT_DESKTOP_DEFAULT,
} from 'views/consts'

import './HorizontalSliderSkeleton.scss'

export const renderItems = ({ items, colSize }) =>
  items.map((_, index) => (
    <li
      className={classNames(
        'o-SkeletonSliderItem',
        'l-col--12-of-12',
        `l-col--${colSize * 2}-of-12@tiny`,
        `l-col--${colSize}-of-12@medium`,
        { 'u-hidden@small-tiny': index >= 2 }
      )}
      key={`slider-item-${index}`}
    >
      <div className="o-SkeletonSliderItem__top" />
      <div className="o-SkeletonSliderItem__bricksContainer">
        <div className="o-SkeletonSliderItem__textBrick u-margin-x-small--bottom" />
        <div className="o-SkeletonSliderItem__textBrick o-SkeletonSliderItem__textBrick--short u-margin--bottom" />

        <div className="o-SkeletonSliderItem__footer">
          <div className="o-SkeletonSliderItem__textBrick o-SkeletonSliderItem__textBrick--medium u-margin--bottom" />
          <div className="o-SkeletonSliderItem__textBrick o-SkeletonSliderItem__textBrick--large o-SkeletonSliderItem__textBrick--medium u-margin-x-small--bottom" />
          <div className="o-SkeletonSliderItem__textBrick o-SkeletonSliderItem__textBrick--medium" />
        </div>
      </div>
    </li>
  ))

const HorizontalSliderSkeleton = ({
  className,
  visibleItemCount,
  noSlider,
}) => {
  const numberOfVisibleItems = visibleItemCount
  const items = new Array(Math.ceil(numberOfVisibleItems)).fill(true)
  const colCount = items.length === 1 ? 4 : numberOfVisibleItems
  const colSize = Math.ceil(12 / colCount)

  const productRow = (
    <ul
      className={classNames('a-list-reset a-list-inline l-flex u-no-overflow', {
        'a-full-width': items.length < DEFAULT_NUMBER_OF_VISIBLE_ITEM,
      })}
    >
      {renderItems({ items, colSize })}
    </ul>
  )

  return (
    <div className={classNames('o-HorizontalSliderSkeleton', className)}>
      <div className="o-HorizontalSliderSkeleton__header" />
      {productRow}
      {noSlider && <div className={'u-margin--top'}> {productRow}</div>}
    </div>
  )
}

HorizontalSliderSkeleton.propTypes = {
  visibleItemCount: number,
  noSlider: bool,
  className: string,
}

HorizontalSliderSkeleton.defaultProps = {
  visibleItemCount: VISIBLE_COUNT_DESKTOP_DEFAULT,
  noSlider: false,
  className: null,
}

export default HorizontalSliderSkeleton
